import { ConditionInfo, PublicService } from 'src/services'
import { useEffect, useState } from 'react'

import { CommonConditionModal } from 'com-ui-biz/shared'
import { SignUpForm } from './SignUpForm'
import { SignUpLayout } from './SignUpLayout'

export const SignUp = () => {
  const [showCondition, setShowCondition] = useState<boolean>(false)
  const [condition, setCondition] = useState<ConditionInfo | undefined>()

  useEffect(() => {
    ;(async () => {
      try {
        const result = await PublicService.condition()
        setCondition(result)
      } catch (error) {
        console.log('cannot get condition')
      }
    })()
  }, [])
  return (
    <SignUpLayout>
      <SignUpForm {...{ setShowCondition, conditionId: condition?.id }} />
      <CommonConditionModal
        open={showCondition}
        setOpen={setShowCondition}
        condition={condition}
        headerText="Seller terms and conditions"
      />
    </SignUpLayout>
  )
}
